import styled, { css } from 'styled-components';

import { TextInput } from '@interstate/components/TextInput';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { FlexCol } from '../../common/Layout.style';

export const StyledTextWithToggleGroupContainer = styled.div`
    display: flex;
    align-items: start;
    gap: 5px;

    @media (max-width: ${BreakPoint.SMALL}) {
        gap: 1px;
    }
`;

export const StyledTextWithToggleGroupText = styled(FlexCol)<{ $isReadOnly?: boolean }>`
    input,
    fieldset,
    div {
        width: auto;
        min-width: auto !important; // override min-width of TextInput
    }

    ${({ $isReadOnly }) =>
        $isReadOnly &&
        css`
            align-items: flex-start;
        `}

    @media (max-width: ${BreakPoint.SMALL}) {
        div {
            width: auto;
            min-width: auto !important; // override min-width of TextInput
        }
    }
`;

export const StyledTextWithToggleGroupToggleCompact = styled(FlexCol)<{
    showLabelLink?: boolean;
}>`
    margin-left: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    button.MuiToggleButtonGroup-grouped:not(:first-of-type) {
        border: 1px solid #b2b2b2;
    }

    @media (max-width: ${BreakPoint.SMALL}) {
        #dollarToggle,
        #percentToggle {
            min-width: 10px;
        }
    }

    ${({ showLabelLink }) =>
        css`
            padding-top: ${showLabelLink ? '1.5rem' : '1.4rem'};
        `}

    button.MuiToggleButton-root:focus-visible {
        outline: 2px solid #005ba8;
        outline-offset: -2px;
    }
`;

export const StyledReadonlyTextInput = styled(TextInput)`
    // input value container
    #ids-input-layout-grid-container > div:nth-child(2) {
        height: 48px;
    }
`;

export const StyledRateFieldTextWithToggleGroupText = styled(FlexCol)`
    gap: 0;
    flex: 1;
`;

export const StyledRateConversionHelperText = styled.div`
    margin-top: 0.5rem;
    padding-left: 0.5rem;
    font-size: 0.75rem;
    color: #5a5a5a;
`;
